import { render, staticRenderFns } from "./MpRestriction.vue?vue&type=template&id=5f655778&"
import script from "./MpRestriction.vue?vue&type=script&lang=js&"
export * from "./MpRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports